import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { routes } from 'const';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AuthorizationWelcomeText() {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  const isAccountActivationForm = useRouteMatch(routes.accountActivation);

  return (
    <div className={classes.authorizationWelcomeText}>
      <Typography className={classes.title} variant="h1" component="h1" color="primary">
        {t('welcome')}
      </Typography>
      <Typography className={classes.subtitle} variant="h2" component="h2" data-testid="welcome-text">
        {t(isAccountActivationForm ? 'please_sign_up_for_an_account' : 'please_login_to_your_account')}
      </Typography>
    </div>
  );
}

export default AuthorizationWelcomeText;
